export default __webpack_public_path__ + "static/yellow_dots3-3e158c6983c675ec2334cb6557e1a9a2.svg";